// Mirrors Waha::EditMessageService::EDIT_WINDOW_MINUTES.
export const EDIT_WINDOW_MINUTES = 15;
export const WHATSAPP_EDIT_WINDOW_MS = EDIT_WINDOW_MINUTES * 60 * 1000;

export function createdAtToMs(createdAt) {
  if (createdAt == null || createdAt === '') return NaN;
  if (typeof createdAt === 'number') {
    return createdAt < 1e12 ? createdAt * 1000 : createdAt;
  }
  return new Date(createdAt).getTime();
}

export function isWithinWhatsappEditWindow(createdAt, now = Date.now()) {
  const createdMs = createdAtToMs(createdAt);
  if (Number.isNaN(createdMs)) return false;
  return now - createdMs <= WHATSAPP_EDIT_WINDOW_MS;
}

export function wahaOutgoingEditBlockReason({
  sourceId,
  createdAt,
  now = Date.now(),
} = {}) {
  if (!isWithinWhatsappEditWindow(createdAt, now)) return 'expired';
  if (!sourceId) return 'no_source_id';
  return null;
}
